import { useMemo } from "react";
import MAILING_PAGES from "../../../types/enums/MailingPages";

export const useDateLabelByStatus = (status: number) => {
  const dateLabel: string = useMemo(() => {
    let title: string = "Sent";

    return `${status === 1 || status === 5 ? "Created" : title} Date`;
  }, [status]);

  return { dateLabel };
};

export const useDateLabelByPage = (page: MAILING_PAGES) => {
  const dateLabel: string = useMemo(() => {
    let title: string = "Sent";

    switch (page) {
      case 0:
      case 5:
        title = "Created";
        break;
      case 2:
      case 3:
      case 4:
        title = "Send";
        break;
      default:
        break;
    }

    return `${title} Date`;
  }, [page]);

  return { dateLabel };
};
